/* eslint-disable no-sequences */
import axios from "axios";
import { apiUrl_forShipping } from "./constants";
const CancelToken = axios.CancelToken;

// get shippings
export let cancelGetShippingsApi;
export async function getShippings(headers) {
    if (headers) {
        const shippings = await axios.get(
            apiUrl_forShipping + "getFedexshipping",
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetShippingsApi = c;
                }),
            }
        );
        return shippings;
    } else {
        console.log("Please add required parameters");
    }
}
// get services
export let cancelGetServicesApi;
export async function getServices(headers) {
    if (headers) {
        const services = await axios.get(
            apiUrl_forShipping + "shipping/services",
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetServicesApi = c;
                }),
            }
        );
        return services;
    } else {
        console.log("Please add required parameters");
    }
}

// get shippings detail
export let cancelGetShippingDetailsApi;
export async function getShippingDetails(headers, id) {
    if (headers && id) {
        const shippingData = await axios.get(
            apiUrl_forShipping + "fedexshipping/edit/" + id,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetShippingDetailsApi = c;
                }),
            }
        );
        return shippingData;
    } else {
        console.log("Please add required parameters");
    }
}

// add shipping
export let cancelAddShippingApi;
export async function addShipping(headers, shippingData) {
    if ((headers && shippingData)) {
        const shipping = await axios.post(
            apiUrl_forShipping + "fedexshipping",
            shippingData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddShippingApi = c;
                }),
            }
        );
        return shipping;
    } else {
        console.log("Please add required parameters");
    }
}

// add shipping
export let cancelSortShippingApi;
export async function sortShipping(headers, shippingData) {
    if ((headers && shippingData)) {
        const shippings = await axios.post(
            apiUrl_forShipping + "shipping/sort",
            shippingData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelSortShippingApi = c;
                }),
            }
        );
        return shippings;
    } else {
        console.log("Please add required parameters");
    }
}

// edit shipping
export let cancelEditShippingApi;
export async function editShipping(headers, shippingData) {
    if ((headers && shippingData)) {
        const shippings = await axios.post(
            apiUrl_forShipping + "fedexshipping/edit/" + shippingData.id,
            shippingData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelEditShippingApi = c;
                }),
            }
        );
        return shippings;
    } else {
        console.log("Please add required parameters");
    }
}

// // update vendors
// export let cancelEditVendorApi;
// export async function editVendor(headers, vendorData) {
//     if (headers && vendorData) {
//         const vendors = await axios.put(apiUrl_forVendors + "vendor/" + vendorData.vendor_id,
//             vendorData,
//             {
//                 headers: { ...headers },
//             },
//             {
//                 cancelToken: new CancelToken(function executor(c) {
//                     cancelEditVendorApi = c;
//                 }),
//             }
//         );
//         return vendors;
//     } else {
//         console.log("Please add required parameters");
//     }
// }

// delete vendors
export let cancelDeleteShippingApi;
export async function deleteShipping(headers, id) {
    if (headers && id) {
        const shipping = await axios.get(
            apiUrl_forShipping + "/shipping/delete/" + id,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteShippingApi = c;
                }),
            }
        );
        return shipping;
    } else {
        console.log("Please add required parameters");
    }
}
